import { InformationCircleIcon } from '@heroicons/react/outline';
import { Box, Typography } from '@mui/material';

const PausePolicyWarningInfo = () => {
  return (
    <Box className="my-5 flex w-full space-x-2 rounded-lg bg-black/5 p-4">
      <InformationCircleIcon className="text-brand-primary h-6 w-6 flex-shrink-0" />
      <Box>
        <Typography className="text-brand-primary font-bold" variant="body2">
          Note!
        </Typography>
        <Typography variant="body2">
          <b>
            You will not be covered for any work you perform during the pause
            period.
          </b>{' '}
          This includes and rectification work or support or advice given to
          clients. If you do perform work, and a claim arises as a result, then
          you will not be covered. You must un-pause your policy prior to
          commencing work to benefit from cover.
        </Typography>
      </Box>
    </Box>
  );
};

export default PausePolicyWarningInfo;
